'use strict';

var Reflux = require('reflux');
var router = require('routers/main');
var LanguageStore = require('stores/language');

/* Actions */
var DatasourceActions = require('actions/datasource');

/* Api */
var DatasourceApi = require('api/datasource');

/* Stores */
var DatasourceStore = Reflux.createStore({

  listenables: [DatasourceActions],

  init: function init() {
    var store = this;

    store.loading = true;
    store.datasources = [];
    store.items = [];
  },

  getInitialState: function getInitialState() {
    var store = this;
    var datasources = store.datasources;

    return datasources;
  },

  onLoadAll: function onLoadAll() {
    var store = this;

    DatasourceApi.load().done(function (data) {
      store.loading = false;
      store.datasources = data;
      store.trigger(store.datasources);
    });
  },

  onLoadItems: function onLoadItems(id) {
    var store = this;

    store.items = [];
    store.trigger(store.datasources);

    DatasourceApi.loadItems(id).done(function (data) {

      store.items = data;
      store.trigger(store.datasources);
    });
  },

  onCreate: function onCreate(datasource) {
    var _this = this;

    router.transitionTo('/');

    DatasourceApi.add(datasource).done(function (data) {
      _this.datasources.unshift(data);
      _this.trigger(_this.datasources);
    });
  },

  onSubmit: function onSubmit(id, props) {
    var _this2 = this;

    router.transitionTo('/');

    DatasourceApi.update(id, props).done(function (newDatasource) {
      // Exchange the new user for the old user
      _this2.datasources = _this2.datasources.map(function (datasource) {
        return datasource.id === id ? newDatasource : datasource;
      });
      _this2.trigger(_this2.datasources);
    });
  },

  onDelete: function onDelete(id) {
    var _this3 = this;

    router.transitionTo('/');

    DatasourceApi['delete'](id).done(function () {
      _this3.datasources = _this3.datasources.filter(function (datasource) {
        return datasource.id !== id;
      });
      _this3.trigger(_this3.datasources);
    });
  },

  onDeleteItems: function onDeleteItems(datasourceId, itemIds) {
    var store = this;

    store.items = store.items.filter(function (item) {
      return !itemIds.includes(item.id);
    });

    store.trigger(store.datasources);

    DatasourceApi.deleteItems(datasourceId, itemIds);
  },

  onCopyItemsTo: function onCopyItemsTo(datasourceId, itemIds) {
    DatasourceApi.copyItemsTo(datasourceId, itemIds);
  },

  onAssignUser: function onAssignUser(datasourceId, userId, permission) {
    var datasources = this.datasources;

    permission = permission || 'readwrite';

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (datasource.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    datasource.users.push({ userId: userId, permission: permission });

    DatasourceApi.update(datasourceId, { users: datasource.users });

    this.trigger(datasources);
  },

  onUnassignUser: function onUnassignUser(datasourceId, userId) {
    var datasources = this.datasources;

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (!datasource.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    datasource.users = datasource.users.filter(function (user) {
      return user.userId !== userId;
    });

    DatasourceApi.update(datasourceId, { users: datasource.users });

    this.trigger(datasources);
  },

  onAssignTeam: function onAssignTeam(datasourceId, teamId, permission) {
    var datasources = this.datasources;

    permission = permission || 'readwrite';

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (datasource.teams.some(function (team) {
      return team.teamId === teamId;
    })) {
      return;
    }

    datasource.teams.push({ teamId: teamId, permission: permission });

    DatasourceApi.update(datasourceId, { teams: datasource.teams });

    this.trigger(datasources);
  },

  onUnassignTeam: function onUnassignTeam(datasourceId, teamId) {
    var datasources = this.datasources;

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (!datasource.teams.some(function (team) {
      return team.teamId === teamId;
    })) {
      return;
    }

    datasource.teams = datasource.teams.filter(function (team) {
      return team.teamId !== teamId;
    });

    DatasourceApi.update(datasourceId, { teams: datasource.teams });

    this.trigger(datasources);
  },

  onAssignProject: function onAssignProject(datasourceId, projectId, permission) {
    var datasources = this.datasources;

    permission = permission || 'readwrite';

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (datasource.projects.some(function (project) {
      return project.projectId === projectId;
    })) {
      return;
    }

    datasource.projects.push({ projectId: projectId, permission: permission });

    DatasourceApi.update(datasourceId, { projects: datasource.projects });

    this.trigger(datasources);
  },

  onUnassignProject: function onUnassignProject(datasourceId, projectId) {
    var datasources = this.datasources;

    var datasource = datasources.find(function (datasource) {
      return datasource.id === datasourceId;
    });

    if (!datasource.projects.some(function (project) {
      return project.projectId === projectId;
    })) {
      return;
    }

    datasource.projects = datasource.projects.filter(function (project) {
      return project.projectId !== projectId;
    });

    DatasourceApi.update(datasourceId, { projects: datasource.projects });

    this.trigger(datasources);
  },

  onChangeForSale: function onChangeForSale(itemId, forSale) {
    DatasourceApi.updateItem(itemId, { forSale: forSale }, {});

    var item = this.items.find(function (item) {
      return item.id === itemId;
    });

    item.forSale = forSale;

    this.trigger(this.datasources);
  },

  onUpdateContent: function onUpdateContent(itemId, changes, removals) {
    DatasourceApi.updateItem(itemId, changes, removals);

    // Add ID to changes.
    changes.id = itemId;

    // Update items view.
    var index = null;

    this.items.forEach(function (item, i) {
      if (item.id === itemId) {
        index = i;
      }
    });

    if (index >= 0) {
      this.items[index] = changes;

      this.trigger(this.datasources);
    }
  },

  onCreateContent: function onCreateContent(datasourceId, selection) {
    var _this4 = this;

    var template = this.getCreateTemplate(selection);

    DatasourceApi.createItem(datasourceId, template).done(function (result) {
      if (!result || !result.catalogueItem || result.error) {
        alert(LanguageStore.translate('content_editor_unspecified_error'));
        return;
      }

      // Sanitize the catalogue item for the view.
      delete result.catalogueItem.__v;
      delete result.catalogueItem._id;
      delete result.catalogueItem.catalogueIds;

      // Add catalogue item to the top of the list.
      _this4.items.splice(0, 0, result.catalogueItem);

      _this4.trigger(_this4.datasources);
    });
  },

  getCreateTemplate: function getCreateTemplate(id) {
    switch (id) {
      case 'book':
        return {
          type: 'ebook',
          contentId: 'Content ID',
          assets: [{
            assetId: 'Asset ID',
            type: 'book',
            category: 'Books',
            title: 'Asset title',
            downloadAvailable: true,
            extension: 'epub',
            downloadUrl: 'Download URL'
          }],
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345,
          contributors: [{
            role: 'author',
            name: 'Author name'
          }],
          publisher: 'Publisher name',
          language: 'da',
          imprint: 'Imprint',
          pageCount: 123
        };
        break;

      case 'movie':
        return {
          type: 'movie',
          contentId: 'Content ID',
          assets: [{
            assetId: 'Asset ID',
            type: 'screener',
            category: 'Screeners',
            title: 'Asset title',
            downloadAvailable: false,
            extension: 'mp4',
            playerToken: 'Player token',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345,
          directors: [{
            name: 'Director name'
          }],
          cast: [{
            name: 'Cast name'
          }],
          productionYear: 2017,
          runtime: 120
        };
        break;

      case 'tvEpisode':
        return {
          type: 'tv-episode',
          contentId: 'Content ID',
          assets: [{
            assetId: 'Asset ID',
            type: 'screener',
            category: 'Screeners',
            title: 'Asset title',
            downloadAvailable: false,
            extension: 'mp4',
            playerToken: 'Player token',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345,
          directors: [{
            name: 'Director name'
          }],
          cast: [{
            name: 'Cast name'
          }],
          number: 123,
          parentId: 'Parent content ID'
        };
        break;

      case 'tvSeason':
        return {
          type: 'tv-season',
          contentId: 'Content ID',
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345,
          directors: [{
            name: 'Director name'
          }],
          cast: [{
            name: 'Cast name'
          }],
          number: 123,
          parentId: 'Parent content ID'
        };
        break;

      case 'tvShow':
        return {
          type: 'tv-series',
          contentId: 'Content ID',
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345,
          directors: [{
            name: 'Director name'
          }],
          cast: [{
            name: 'Cast name'
          }]
        };
        break;

      case 'bundle':
        return {
          type: 'bundle',
          contentId: 'Content ID',
          bundleIds: ['Bundled content ID'],
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345
        };
        break;

      case 'subscription':
        return {
          type: 'subscription',
          renewal: 30,
          trial: true,
          contentId: 'Content ID',
          artwork: [{
            assetId: 'Asset ID',
            type: 'facing',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner-compact',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }, {
            assetId: 'Asset ID',
            type: 'banner',
            rel: {
              thumbnail: 'Thumbnail URL',
              preview: 'Preview URL'
            }
          }],
          localized: [{
            synopsis: 'Localized synopsis',
            title: 'Localized title',
            locale: 'da',
            subtitle: 'Localized subtitle'
          }],
          store: {
            licensors: [{
              role: 'owner',
              title: 'Licensor name',
              licensorId: 123
            }]
          },
          price: {
            purchase: {
              value: 1234,
              currency: 'DKK'
            }
          },
          genre: ['Genre'],
          tags: ['Tag'],
          categories: ['Category'],
          releaseDate: '2017-01-01',
          browserDescription: 'Browser description',
          browserTitle: 'Browser title',
          title: 'Original title',
          mcAssetId: 12345
        };
        break;

      case 'discountVoucher':
        return {
          code: 'Voucher code',
          discount: {
            type: 'percentage',
            amount: 50,
            contentIds: ['Content ID']
          },
          tags: ['Tag'],
          reusable: true
        };
        break;

      case 'voucher':
        return {
          code: 'Voucher code',
          tags: ['Tag'],
          reusable: true
        };
        break;

      case 'order':
        return {
          orderType: 'purchase',
          contents: [{
            store: {
              licensors: [{
                licensorId: 123,
                title: 'Licensor name',
                role: 'owner'
              }]
            },
            currency: 'DKK',
            value: 1234,
            orderType: 'purchase',
            amount: 1,
            contentId: 'Content ID',
            contentTitle: 'Content title'
          }],
          numericalOrderId: 12345,
          status: 'paid',
          totalValue: 1234,
          totalAmount: 1,
          vatPrice: 0,
          vat: 0,
          currency: 'DKK',
          userId: 'User ID',
          paidAt: new Date(),
          transactionFee: 0,
          transactionNumber: 12345,
          paymentMethodId: '1',
          paymentMethod: 'Payment card or other (1)'
        };
        break;

      case 'user':
        return {
          username: 'customer@email.com',
          conditions: true,
          info: [{
            fields: [{
              value: 'Customer first name',
              fieldType: 'text',
              name: 'firstname'
            }],
            name: 'name'
          }],
          email: 'customer@email.com',
          siteId: 'Published site ID'
        };
        break;

      default:
        return {};
        break;
    }
  }

});

module.exports = DatasourceStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/datasource.js
 **/